import React from 'react'
import './TrendingArtistCard.css';
import { FaRegHeart } from "react-icons/fa";
import { HiOutlineUserAdd } from "react-icons/hi";
import { FaUserCheck } from "react-icons/fa6";
import { API_BASE_URL } from '../../utils';


export default function TrendingArtistCard({ data }) {

    const url = `${API_BASE_URL}/master/assets/uploads/`;

    return (
        <>
            <div className='TrendingArtistCard'>
                <div className='TrendingArtistCard-wrapper'>
                    <div className='TrendingArtistCard-image'>
                    <img src={url + data.profile_pic} alt={data.name} />
                    <div className='TrendingArtistCard-overlay'>
                        <span><FaRegHeart /></span>
                        <span><HiOutlineUserAdd /></span>
                        <span><FaUserCheck /></span>
                    </div>
                    </div>
                    <h2>{data.name}</h2>
                </div>
            </div>
        </>
    )
}
